/**
 * Constants for BorrowerBizProfile component
 */

import { BizProfileFormErrors } from "./types";

/**
 * Initial empty error state
 */
export const INITIAL_ERRORS: BizProfileFormErrors = {
  companyName: "",
  registrationNumber: "",
  companyStartDate: "",
  legalStructure: "",
  industryGroup: "",
  institutionType: "",
  industryOthers: undefined,
  countryOfIncorporation: "",
  countryOfDomicile: "",
  region: "",
  city: "",
  address: "",
  phoneNumber: "",
  postalcode: "",
  companyWebsite: "",
  financialTurnover: "",
};

/**
 * Toast messages
 */
export const TOAST_MESSAGES = {
  DRAFT_SAVED: "Draft Saved",
  ERROR_FETCHING_DRAFT: "Error fetching draft",
} as const;

/**
 * Required field error messages
 * Maps field names to their error messages
 */
export const REQUIRED_FIELD_ERRORS: Record<string, string> = {
  companyName: "Company Name is required",
  registrationNumber: "Registration Number is required",
  companyStartDate: "Date of Incorporation is required",
  legalStructure: "Legal Structure is required",
  industryGroup: "Industry Group is required",
  institutionType: "Industry is required",
  countryOfIncorporation: "Country of Incorporation is required",
  countryOfDomicile: "Country of Domicile is required",
  address: "Address is required",
  phoneNumber: "Phone Number is required",
  postalcode: "Postal Code is required",
  companyWebsite: "Company Website is required",
};
